import AtEditor from './components/main'

export {
  AtEditor
}

export default {
  install(Vue) {
    Vue.component('at-editor', AtEditor)
  }
}



// WEBPACK FOOTER //
// ./src/packages/components/editor/index.js